import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TwoFactorOnetimeModalComponent } from '@clubhub/components/two-factor-onetime-modal/two-factor-onetime-modal.component';
import { AuthorizeService } from '@shared/services/authorize.service';
import { ModalService } from '@shared/services/modal.service';

export const twoFactorOnetimeGuard: CanActivateFn = async () => {
  const authorizeService = inject(AuthorizeService);
  const modalService = inject(ModalService);

  // Show only if: the user is SSO, has pressed 'remember me', and has not seen the popup before.
  if (
    authorizeService.isSsoUser &&
    localStorage.getItem('emailVerificationToken') &&
    !localStorage.getItem('twoFactorOnetimePopupShown')
  ) {
    localStorage.setItem('twoFactorOnetimePopupShown', 'true');

    modalService.openRef({
      component: TwoFactorOnetimeModalComponent,
      size: 'md',
    });
  }

  return true;
};
